import React, { useState, useEffect, Fragment, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

import { makeStyles } from "@mui/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { Payment, Add, Refresh, OpenInNew } from "@mui/icons-material";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import clsx from "clsx";
import { DataGrid } from "@mui/x-data-grid";
import Moment from "moment";
import axios from "axios";
import {
  Alert,
  Grid,
  Box,
  DialogContent,
  DialogActions,
  Dialog,
} from "@mui/material";

import errorImg from "assets/img/error.png";
import successImg from "assets/img/success.gif";
import loaderGif from "assets/img/loading.gif";

import {
  ButtonStyle0,
  cardBodyStyle,
  ButtonExit,
  ButtonTableGrid1,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

// row = el registro de external_supplier (viene del listado ExternalSupplierListAdmin)
export default function ExternalSupplierInvoicesAdmin({
  open,
  exit,
  row,
  callBackRefresh,
}) {
  const classes = useStyles();

  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [rows, setRows] = useState([]);
  const [loaderGenerate, setLoaderGenerate] = useState(false);
  const [generate, setGenerate] = useState(false);
  const [returnLogin, setReturnLogin] = useState(false);
  const [disabledGenerate, setDisabledGenerate] = useState(true);
  const [responseInvoices, setResponseInvoices] = useState({
    msg: "",
    img: "",
  });

  const { urlServices, UserAuth, ViewFactGenerate } =
    useContext(UrlServicesContext);
  const keyAuthorization = UserAuth?.Session;

  const [state] = useState({
    columns: [
      {
        headerName: "Documento",
        field: "invoiceDocument",
        flex: 1,
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => clsx("super-app", { celAll: params.value }),
        renderCell: (params) => (
          <b style={{ color: params.value !== "0" ? "#000" : "red" }}>
            {params.value !== "0" ? params.value : "Documento no generado"}
          </b>
        ),
        sortable: false,
        hideable: false,
      },
      {
        headerName: "Factura",
        field: "responseMessage",
        width: 180,
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => clsx("super-app", { celAll: params.value }),
        renderCell: (params) => (
          <ButtonTableGrid1
            style={{
              fontSize: 10,
              display: params.row.invoiceDocument !== "0" ? "flex" : "none",
            }}
            component="a"
            target="_blank"
            href={`${ViewFactGenerate}${params.row.responseMessage?.claveAcceso}`}
          >
            Ver factura <OpenInNew sx={{ fontSize: 16, ml: 0.3 }} />
          </ButtonTableGrid1>
        ),
        align: "center",
        sortable: false,
        hideable: false,
      },
      {
        headerName: "Estado",
        field: "status",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          const status = params.value === 1 ? "APROBADA" : "ERROR";
          return (
            <b
              style={{
                fontSize: 12,
                color: status === "APROBADA" ? "green" : "red",
              }}
            >
              {status}
            </b>
          );
        },
        cellClassName: (params) => clsx("super-app", { celAll: params.value }),
        align: "center",
        width: 130,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Fecha Creación",
        field: "createdAt",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => (
          <span>{Moment(params.value).format("DD-MM-YYYY HH:mm")} </span>
        ),
        cellClassName: (params) => clsx("super-app", { celAll: params.value }),
        align: "center",
        width: 160,
        sortable: false,
        filtering: false,
        hideable: false,
      },
    ],
  });

  useEffect(() => {
    if (row?.id) {
      RefreshTable();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row?.id]);

  const RefreshTable = async () => {
    setLoader(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlServices}external-supplier-invoice/list/${row.id}`,
        { headers: { Authorization: "Bearer " + keyAuthorization } },
      );

      const data = response.data.map((inv) => {
        let responseMessage = inv.responseMessage;
        try {
          responseMessage =
            inv.invoiceDocument !== "0"
              ? JSON.parse(inv.responseMessage)
              : inv.responseMessage;
        } catch {
          /* deja el string tal cual si no es JSON */
        }
        return { ...inv, responseMessage };
      });

      setRows(data);
      // Se habilita "Generar factura" solo si aún no hay ninguna exitosa
      setDisabledGenerate(data.some((inv) => inv.status === 1));
    } catch (e) {
      handleError(e);
    } finally {
      setLoader(false);
    }
  };

  const GenerateValue = () => async () => {
    setError(false);
    setGenerate(true);
    setLoaderGenerate(true);

    try {
      const response = await axios.post(
        `${urlServices}external-supplier-invoice/generate`,
        { externalSupplierId: row.id },
        { headers: { Authorization: "Bearer " + keyAuthorization } },
      );

      if (response.status === 201) {
        setResponseInvoices({
          msg: "Factura generada con éxito.",
          img: successImg,
        });
      }
    } catch (e) {
      setResponseInvoices({
        msg: e.response?.data?.message || "Hay un error al generar la factura.",
        img: errorImg,
      });
    } finally {
      setLoaderGenerate(false);
      await RefreshTable();
      if (callBackRefresh) callBackRefresh();

      setTimeout(() => {
        setGenerate(false);
      }, 3000);
    }
  };

  const handleCloseDialog = () => {
    exit();
  };

  const handleError = (error) => {
    if (error.response?.status === 401) {
      setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
      setError(true);
      setTimeout(() => {
        localStorage.clear();
        setReturnLogin(true);
      }, 4000);
    } else if (error.response?.status === 404) {
      setMensageSystem("Registro no encontrado.");
      setError(true);
    } else if (error.response?.status === 500) {
      setMensageSystem("Error en la consulta con el servidor.");
      setError(true);
    } else {
      console.error("Error en la solicitud:", error);
      setMensageSystem("Error al realizar la solicitud.");
      setError(true);
    }
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="md"
        onClose={handleCloseDialog}
        open={open}
        keepMounted
        scroll="body"
        PaperProps={{ sx: { borderRadius: 6 } }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.cardTitleBlack}>
                <Payment className={classes.iconFilter} /> Facturación —{" "}
                {row?.nameClient} {row?.lastnameClient}
              </div>
              <Card>
                <CardBody>
                  <Fragment>
                    <Grid container>
                      <Grid item xs={12} sm={12}>
                        {error && (
                          <Alert severity="error">{mensageSystem}</Alert>
                        )}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        sx={{ display: !disabledGenerate ? "block" : "none" }}
                      >
                        <div style={{ float: "right", marginBottom: 8 }}>
                          <ButtonStyle0
                            onClick={GenerateValue()}
                            endIcon={rows.length > 0 ? <Refresh /> : <Add />}
                          >
                            {rows.length > 0
                              ? "Reintentar factura"
                              : "Generar factura"}
                          </ButtonStyle0>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        {loader ? (
                          <center>
                            <img
                              alt="loaderGif"
                              src={loaderGif}
                              style={{ width: 60, margin: "8% 0" }}
                            />
                          </center>
                        ) : rows.length > 0 ? (
                          <Box
                            sx={{
                              "& .super-app.celAll": { fontSize: 12 },
                              "& .super-app-theme--header": {
                                backgroundColor: "rgb(242, 242, 242)",
                              },
                              marginTop: 2,
                            }}
                          >
                            <DataGrid
                              rows={rows}
                              columns={state.columns}
                              initialState={{
                                pagination: {
                                  paginationModel: { page: 0, pageSize: 10 },
                                },
                              }}
                              pageSizeOptions={[5, 10, 20, 50]}
                              disableRowSelectionOnClick
                              checkboxSelection={false}
                              autoHeight
                            />
                          </Box>
                        ) : (
                          <Alert severity="info" sx={{ mt: 2 }}>
                            Este pago aún no tiene ninguna factura generada.
                          </Alert>
                        )}
                      </Grid>
                    </Grid>
                  </Fragment>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>

          {/* Modal de progreso al generar */}
          <Dialog
            open={generate}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: 6 } }}
          >
            <DialogContent>
              <center>
                {loaderGenerate ? (
                  <>
                    <img
                      alt="loaderGif"
                      src={loaderGif}
                      style={{ width: 60, margin: "8% 0 1% 0" }}
                    />
                    <div
                      className={classes.cardTitleBlack}
                      style={{ fontSize: 14, marginBottom: 20 }}
                    >
                      Generando factura
                    </div>
                  </>
                ) : (
                  <>
                    <img
                      alt="msgImg"
                      src={responseInvoices.img}
                      style={{ width: 100, margin: "8% 0 1% 0" }}
                    />
                    <div
                      className={classes.cardTitleBlack}
                      style={{ fontSize: 16, marginBottom: 20 }}
                    >
                      {responseInvoices.msg}
                    </div>
                  </>
                )}
              </center>
            </DialogContent>
          </Dialog>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
